export enum RecallType {
    Code,
    Text,
}
